import Vue from 'vue'
import Router from 'vue-router'

// Containers
import DefaultContainer from '@/containers/DefaultContainer'

// Views
import Dashboard from '@/views/Dashboard'

import Colors from '@/views/theme/Colors'
import Typography from '@/views/theme/Typography'

import Charts from '@/views/Charts'
import Widgets from '@/views/Widgets'

// Views - Components
import Cards from '@/views/base/Cards'
import Forms from '@/views/base/Forms'
import Switches from '@/views/base/Switches'
import Tables from '@/views/base/Tables'
import Tabs from '@/views/base/Tabs'
import Breadcrumbs from '@/views/base/Breadcrumbs'
import Carousels from '@/views/base/Carousels'
import Collapses from '@/views/base/Collapses'
import Jumbotrons from '@/views/base/Jumbotrons'
import ListGroups from '@/views/base/ListGroups'
import Navs from '@/views/base/Navs'
import Navbars from '@/views/base/Navbars'
import Paginations from '@/views/base/Paginations'
import Popovers from '@/views/base/Popovers'
import ProgressBars from '@/views/base/ProgressBars'
import Tooltips from '@/views/base/Tooltips'

// Views - Buttons
import StandardButtons from '@/views/buttons/StandardButtons'
import ButtonGroups from '@/views/buttons/ButtonGroups'
import Dropdowns from '@/views/buttons/Dropdowns'
import BrandButtons from '@/views/buttons/BrandButtons'

// Views - Icons
import Flags from '@/views/icons/Flags'
import FontAwesome from '@/views/icons/FontAwesome'
import SimpleLineIcons from '@/views/icons/SimpleLineIcons'
import CoreUIIcons from '@/views/icons/CoreUIIcons'

// Views - Notifications
import Alerts from '@/views/notifications/Alerts'
import Badges from '@/views/notifications/Badges'
import Modals from '@/views/notifications/Modals'

// Views - Pages
import Page404 from '@/ErrorPage/containers/Page404'
import Page500 from '@/ErrorPage/containers/Page500'

// import demoTemplate from './demoTemplate'
import MyContainer from '@/containers/MyContainer'
import H5Container from '@/containers/H5Container'


import Homepage from '@/Homepage/route'
import Auth from '@/Auth/route'
import ErrorPage from '@/ErrorPage/route'

// Kol-h5
import Product from '@/Product/route'
import Package from '@/Package/route'
import Account from '@/Account/route'
import Cart from '@/Cart/route'
import Shop from '@/Shop/route'

// import Payment from '@/Payment/route'

import Cookies from 'js-cookie'
Vue.use(Router)
const role = Cookies.get('role');
export default new Router({
  mode: 'history',
  base: process.env.PREFIX_PATH,
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    Auth,
    ErrorPage,
    {
      path: '/',
      name: 'Home',
      redirect:'/product/list',
      meta: { label: 'Homepage' },
      component: H5Container,
      children: [
        Product,
        Package,
        Shop,
        Cart,
        Account       
      ]
    },
    // {
    //   path: '/dashboard',
    //   name: 'Home',
    //   meta: { label: 'hm' },
    //   component: MyContainer,
    //   children: [
    //     Homepage.dashboard,
    //     Homepage.clientDashboard,
    //     Homepage.clientPolicyDetail,

    //   ]
    // },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js